export const ProjectsCtaBannerDict = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    None: "None",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ProjectsCta: "ProjectsCta",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    UsersCta: "UsersCta",
} as const;

export type ProjectsCtaBannerType = (typeof ProjectsCtaBannerDict)[keyof typeof ProjectsCtaBannerDict];
